// extracted by mini-css-extract-plugin
export default {"container":"HkUJ77","notFirstItem":"y2aod_","pimple":"OuMiQT","updatedIndicationText":"TG8zlA"};